import { MouseEvent, ReactElement } from 'react';
import { CatalogFilters, CatalogPagination, CatalogTitle } from '@client/catalog/components/Catalog';
import { ResultsActiveFilters } from '@client/catalog/components/ResultsActiveFilters';
import { ResultsProductList } from '@client/catalog/components/ResultsProductList';
import { ResultsViewOptions } from '@client/catalog/components/ResultsViewOptions';
import { useTranslate } from '@client/i18n/hooks';
import { Loader, LOADER_STYLE_TYPE } from '@lib/components/Loader';
import { Button, BUTTON_SIZE } from 'b2b-components/theme/components/Button';
import { Props } from './Catalog.types';
import './Catalog.scss';

export const Catalog = ({
  catalog,
  title,
  children = null,
  isLevelZeroAvailable = false,
  availableFacetFilters,
  activeFacetFilters,
  activeFacetFiltersCount,
  onFilterChange,
}: Props): ReactElement => {
  const t = useTranslate();

  const renderMobileFilters = (closeModal: (e: MouseEvent<HTMLButtonElement>) => void): ReactElement | null => {
    if (catalog.isLoading) {
      return <Loader styleType={LOADER_STYLE_TYPE.fullScreen} />;
    }

    if (catalog.data) {
      return (
        <>
          <Button
            className='Catalog-MobileFiltersClose'
            onClick={closeModal}
            size={BUTTON_SIZE.small}
          >
            {t('Apply')}
          </Button>

          <ResultsActiveFilters
            activeFilters={activeFacetFilters}
            onFilterChange={onFilterChange}
          />

          <CatalogFilters
            isLevelZeroAvailable={isLevelZeroAvailable}
            availableFacetFilters={availableFacetFilters}
            onFilterChange={onFilterChange}
          />
        </>
      );
    }

    return null;
  };

  return (
    <>
      <section className='Catalog-Filters'>
        <CatalogFilters
          isLevelZeroAvailable={isLevelZeroAvailable}
          availableFacetFilters={availableFacetFilters}
          onFilterChange={onFilterChange}
        />
      </section>

      <section className='Catalog-Results'>
        <CatalogTitle title={title} />

        {children}

        <ResultsViewOptions
          countFilters={activeFacetFiltersCount}
          renderMobileFilters={renderMobileFilters}
        />

        <ResultsActiveFilters
          activeFilters={activeFacetFilters}
          allowCoreAssortment
          onFilterChange={onFilterChange}
        />

        {catalog.isLoading
          ? <Loader />
          : <ResultsProductList products={catalog.data.products} />
        }

        <CatalogPagination />
      </section>
    </>
  );
};
